export default "__VITE_ASSET___m47FlKP__"